import React, { useEffect, useRef } from "react"
import { CybersourcePayment } from "@ssc-booking/api-contracts"
import { useConfig } from "../../../_common/hooks/use-config"

type Props = {
    target: string
    payment: CybersourcePayment
}

const CybersourcePay: React.FC<React.PropsWithChildren<Props>> = ({ target, payment }) => {
    const btnRef = useRef<HTMLButtonElement>(null)
    const config = useConfig()
    const cybersourceEndpoint = config.cybersourceUrl

    useEffect(() => {
        const timer = setTimeout(() => {
            btnRef.current?.click()
        }, 200)
        return () => clearTimeout(timer)
    }, [])

    return (
        <form action={cybersourceEndpoint} method="post" target={target}>
            {Object.keys(payment.payload).map((name) => (
                <input type="hidden" name={name} value={payment.payload[name]} key={name} />
            ))}
            <input type="hidden" name="signature" value={payment.signature} />
            <button hidden={true} ref={btnRef}>
                Checkout
            </button>
        </form>
    )
}

export default CybersourcePay
